import { render } from "./InputNumber.vue?vue&type=template&id=a2635de4"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"

import "./InputNumber.vue?vue&type=style&index=0&id=a2635de4&lang=css"
script.render = render

export default script